import axios from "axios";
import { API_URL, FOLDERPATH } from "../Constants/config";
import { toast } from "react-toastify";
import {
  CREDIT_EXPERIAN_LOADING,
  CREDIT_EXPERIAN_SUCCESS,
  CREDIT_EXPERIAN_FAILED,
  SAVE_CREDIT_EXPERIAN_LOADING,
  SAVE_CREDIT_EXPERIAN_SUCCESS,
  SAVE_CREDIT_EXPERIAN_FAILED,
  VALIDATE_OTP_LOADING,
  VALIDATE_OTP_SUCCESS,
  VALIDATE_OTP_FAILED,
  SAVE_EXPERIAN_LOADING,
  SAVE_EXPERIAN_SUCCESS,
  SAVE_EXPERIAN_FAILED,
  PINCODE_CIBIL_LOADING,
  PINCODE_CIBIL_SUCCESS,
  PINCODE_CIBIL_FAILED,
  PHONE_VERIFICATION_LOADING,
  PHONE_VERIFICATION_SUCCESS,
  PHONE_VERIFICATION_FAILED,
  VERIFY_EXPERIAN_ANSWERS_LOADING,
  VERIFY_EXPERIAN_ANSWERS_SUCCESS,
  VERIFY_EXPERIAN_ANSWERS_FAILED,
  ALTERNATE_PHONE_LIST_LOADING,
  ALTERNATE_PHONE_LIST_SUCCESS,
  ALTERNATE_PHONE_LIST_FAILED,
} from "../Constants/creditExperianHistoryConstants";

import { handleApiError } from "../Helper/actionHelper";

export const creditExperianHistory = () => async (dispatch) => {
  try {
    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));

    dispatch({ type: CREDIT_EXPERIAN_LOADING });

    const requestData = {
      token: userLocalData.id,
    };

    //return false;
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data } = await axios.post(
      FOLDERPATH + "/CandidateApi/creditHistory",
      requestData,
      {
        headers: headers,
      }
    );

    dispatch({
      type: CREDIT_EXPERIAN_SUCCESS,
      payload: data,
    });
    const msg = data.message;

    toast.error(msg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    handleApiError(data);
  } catch (error) {
    dispatch({
      type: CREDIT_EXPERIAN_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
    handleApiError(error);
  }
};

export const fetchBankAndAmountData = (payload = {}, callback=()=>{}) => async (dispatch) => {
  try {
    dispatch({ type: VERIFY_EXPERIAN_ANSWERS_LOADING });

    let userLocalData = JSON.parse(
      localStorage.getItem("userVerificationCandidate")
    );

    const requestData = {
      token: userLocalData.id,
      ...payload
    };
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data: result } = await axios.post(
      FOLDERPATH + "/CandidateApi/creditHistory",
      requestData,
      {
        headers,
      }
    );
    console.log(result, "resultquestion")
    toast.dismiss();
    callback(result,payload);

    if (result.success === 1) {
      const { question, optionsSet1, optionsSet2, qid } = result.data; // Assuming API returns banks and amounts array

      dispatch({
        type: VERIFY_EXPERIAN_ANSWERS_SUCCESS,
        payload: { question, banks: optionsSet1, amounts: optionsSet2, qid : qid }, // Pass banks and amounts data to the reducer
      });

      const msg = result.msg;
      // toast.success(msg, {
      //   position: "top-right",
      //   autoClose: 5000,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      // });
    } else {
      dispatch({
        type: VERIFY_EXPERIAN_ANSWERS_FAILED,
        payload: result?.msg,
      });

      toast.error(result?.msg?.msg || result?.msg , {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }

    handleApiError(result);
  } catch (error) {
    dispatch({
      type: VERIFY_EXPERIAN_ANSWERS_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
    handleApiError(error);
  }
};

export const creditHistoryVerifyViaAlternatePhoneNo = (record = {}, callback = () => {}) => async (dispatch) => {
  try {
    dispatch({ type: ALTERNATE_PHONE_LIST_LOADING });

    let userLocalData = JSON.parse(
      localStorage.getItem("userVerificationCandidate")
    );

    const requestData = {
      token: userLocalData.id,
      ...record,
    };
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data: result } = await axios.post(
      FOLDERPATH + "/CandidateApi/creditHistory",
      requestData,
      {
        headers,
      }
    );

    callback(result);
    if (result.success == "1") {
      const { data } = result;

      dispatch({
        type: ALTERNATE_PHONE_LIST_SUCCESS,
        payload: result,
      });

      const msg = result.msg;
    } else {
      dispatch({
        type: ALTERNATE_PHONE_LIST_FAILED,
        payload: result,
      });

      const msg = result.msg;

      if(result?.success == 0) {
      //         toast.error(msg, {
      //   position: "top-right",
      //   autoClose: 5000,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      // });
      } else if(result?.msg == "Transaction already completed. It is duplicate request.") {
        toast.error("Something went wronng...", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      }
    }

    handleApiError(result);
  } catch (error) {
    dispatch({
      type: ALTERNATE_PHONE_LIST_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
    handleApiError(error);
  }
};

export const sendOTPExperianHistory = (record,callback=()=>{}) => async (dispatch) => {
  try {
    dispatch({ type: SAVE_CREDIT_EXPERIAN_LOADING });

    let userLocalData = JSON.parse(
      localStorage.getItem("userVerificationCandidate")
    );

    const requestData = {
      token: userLocalData.id,
      ...record,
    };
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data: result } = await axios.post(
      FOLDERPATH + "/CandidateApi/creditHistory",
      requestData,
      {
        headers,
      }
    );

    if (result.success == "1") {
      const { data } = result;

      dispatch({
        type: SAVE_CREDIT_EXPERIAN_SUCCESS,
        payload: result,
      });

      const msg = result.msg;

      /*toast.success(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });*/
    } else {
      dispatch({
        type: SAVE_CREDIT_EXPERIAN_SUCCESS,
        payload: result,
      });

      const msg = result.msg;

      toast.success(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    callback(record, result);

    handleApiError(result);
  } catch (error) {
    dispatch({
      type: SAVE_CREDIT_EXPERIAN_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
    handleApiError(error);
  }
};

export const validateExperianOtp = (record, callback = () => {}) => async (dispatch) => {
  try {
    dispatch({ type: VALIDATE_OTP_LOADING });

    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));

    const requestData = {
      token: userLocalData.id,
      ...record
    };
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };
    const { data: result } = await axios.post(
      FOLDERPATH + "/CandidateApi/creditHistory",
      requestData,
      {
        headers,
      }
    );

    console.log(result);
      callback(result, record);
    if (result.success == "1") {
      const { data } = result;

      dispatch({
        type: VALIDATE_OTP_SUCCESS,
        payload: result,
      });

      const msg = result.msg;

      // toast.success(msg, {
      //   position: "top-right",
      //   autoClose: 5000,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      // });
    } else {
      dispatch({
        type: VALIDATE_OTP_SUCCESS,
        payload: result,
      });

      const msg = result.msg;

      toast.error(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }

    handleApiError(result);
  } catch (error) {
    dispatch({
      type: VALIDATE_OTP_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
    handleApiError(error);
  }
};

export const saveExperianHistory = (record) => async (dispatch) => {
  try {
    dispatch({ type: SAVE_EXPERIAN_LOADING });

    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));

    const requestData = {
      token: userLocalData.id,
    };
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data: result } = await axios.post(
      FOLDERPATH + "/CandidateApi/updateCreditFields",
      requestData,
      {
        headers,
      }
    );

    if (result.success == "1") {
      const { data } = result;

      dispatch({
        type: SAVE_EXPERIAN_SUCCESS,
        payload: result,
      });

      const msg = result.msg;

      toast.success(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      dispatch({
        type: SAVE_EXPERIAN_SUCCESS,
        payload: result,
      });

      const msg = result.msg;

      toast.error(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }

    handleApiError(result);
  } catch (error) {
    dispatch({
      type: SAVE_EXPERIAN_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
    handleApiError(error);
  }
};

export const getPincode = (record) => async (dispatch) => {
  try {
    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
    dispatch({ type: PINCODE_CIBIL_LOADING });

    const requestData = {
      token: userLocalData.id,
      pincode: record,
    };

    //return false;
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    //axios.defaults.baseURL = API_URL;

    const { data } = await axios.post(
      FOLDERPATH + "/GenericApi/getStateAndCityForPincode",
      requestData,
      {
        headers,
      }
    );

    dispatch({
      type: PINCODE_CIBIL_SUCCESS,
      payload: data,
    });
    handleApiError(data);
  } catch (error) {
    dispatch({
      type: PINCODE_CIBIL_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
    handleApiError(error);
  }
};

export const deletePincodeDetails = () => (dispatch) => {
  dispatch({
    type: PINCODE_CIBIL_SUCCESS,
    payload: [],
  });
};

export const deleteSaveExperianDetails = () => (dispatch) => {
  dispatch({
    type: SAVE_EXPERIAN_SUCCESS,
    payload: [],
  });
};

export const deleteOTPExperianDetails = () => (dispatch) => {
  dispatch({
    type: SAVE_CREDIT_EXPERIAN_SUCCESS,
    payload: [],
  });
};

export const deleteMatchOTPDetails = () => (dispatch) => {
  dispatch({
    type: VALIDATE_OTP_SUCCESS,
    payload: [],
  });
};

export const deleteCreditExperianHistory = () => (dispatch) => {
  dispatch({
    type: CREDIT_EXPERIAN_SUCCESS,
    payload: [],
  });
}